import { render, staticRenderFns } from "./CompilationsList.vue?vue&type=template&id=68d0192c&scoped=true"
import script from "./CompilationsList.vue?vue&type=script&lang=js"
export * from "./CompilationsList.vue?vue&type=script&lang=js"
import style0 from "./CompilationsList.vue?vue&type=style&index=0&id=68d0192c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d0192c",
  null
  
)

export default component.exports